import React from 'react';
import { Link } from 'react-router-dom';

/**
 * The detail-page breadcrumb trail (issue 197): Home › {list} › {name}.
 *
 * The trail is HIERARCHY plus ORIGIN, not history: the middle crumb names this
 * entry's own Family and, when the visit originated at a filtered list, carries
 * that exact list URL (`listTo` — computed by `GenericDetail` from the same
 * router state the back link reads, so there is one notion of "where I came
 * from", not two). On a deep link it degrades to the bare list route, which is
 * the issue's own answer to its open question.
 *
 * Accessibility is the standard breadcrumb shape: a `nav` with an accessible
 * name, an ordered list, separators hidden from the accessibility tree, and
 * the current page marked `aria-current="page"`.
 *
 * The current-page crumb truncates rather than wrapping the trail off-screen —
 * a long entity name on a phone is the overflow class `mobile-overflow.spec.js`
 * exists for.
 */
export default function Breadcrumbs({ listLabel, listTo, current }) {
  return (
    <nav aria-label="Breadcrumb" className="breadcrumbs">
      <ol className="flex items-center gap-1.5 min-w-0">
        <li className="flex-shrink-0">
          <Link to="/" className="breadcrumb-link">Home</Link>
        </li>
        <li aria-hidden="true" className="breadcrumb-sep flex-shrink-0">›</li>
        <li className="flex-shrink-0">
          <Link to={listTo} className="breadcrumb-link">{listLabel}</Link>
        </li>
        <li aria-hidden="true" className="breadcrumb-sep flex-shrink-0">›</li>
        <li aria-current="page" className="breadcrumb-current truncate min-w-0">
          {current}
        </li>
      </ol>
    </nav>
  );
}
